"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagValue = void 0;
var TagValue;
(function (TagValue) {
    TagValue["API_ENDPOINT_STATUS_CLASS_2XX"] = "2xx";
    TagValue["API_ENDPOINT_STATUS_CLASS_3XX"] = "3xx";
    TagValue["API_ENDPOINT_STATUS_CLASS_4XX"] = "4xx";
    TagValue["API_ENDPOINT_STATUS_CLASS_5XX"] = "5xx";
    TagValue["BASIC_AUTH_SET_PRIMARY"] = "primary";
    TagValue["BASIC_AUTH_SET_SECONDARY"] = "secondary";
    TagValue["MONITOR_SERVICE_HEALTH_CATEGORY_AVAILABILITY"] = "availability";
    TagValue["MONITOR_SERVICE_HEALTH_CATEGORY_LATENCY"] = "latency";
    TagValue["MONITOR_SERVICE_HEALTH_CATEGORY_THROUGHPUT"] = "throughput";
    TagValue["STATUS_FAILURE"] = "failure";
    TagValue["STATUS_SUCCESS"] = "success";
    TagValue["UNKNOWN"] = "unknown";
})(TagValue = exports.TagValue || (exports.TagValue = {}));
//# sourceMappingURL=tagValues.js.map